import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { TaskList, TaskListCollection } from './queryBuilder';

const useSelectedTask = (pkAssetInspectionTask: number) => {
  const getTaskQuery = useCallback(
    (collection: TaskListCollection) => collection?.find({ selector: { pkAssetInspectionTask } }),
    [pkAssetInspectionTask],
  );

  const { result, isFetching: isTaskDetailLoading } = useRxData<TaskList>(
    RxdbCollectionName.TASK_LIST,
    getTaskQuery,
  );

  return { taskData: result[0], isTaskDetailLoading };
};

export default useSelectedTask;
